<template>
  <div class="BarcodeBox mb-5">
    <div :style="{ margin: boxMargin }">
      <div class="s-full">
        <table class="barcode__table align-center border" cellpadding="5px">
          <tr>
            <td colspan="2"><span class="bold customer_name"><AFitText>{{data.customer_name}}</AFitText></span></td>
          </tr>
          <tr>
            <td width="150px">사 이 즈</td>
            <td>{{data.size}}{{getProductCategory(data)}}</td>
          </tr>
          <tr>
            <td>출 고 일</td>
            <td>{{data.delivery_date}}</td>
          </tr>
          <tr style="height:130px;">
            <td>사 양</td>
            <td class="font-small">{{data.specification}}</td>
          </tr>
          <tr>
            <td>현 장</td>
            <td><AFitText>{{data.field}}</AFitText></td>
          </tr>
        </table>
        <div class="flex-fixed barcode">
          <div class="of-hidden border" style="border-top: none; width: 528px;">
            <VueBarcode 
              height="100" 
              margin="0" 
              :width="5.2"
              :value="data.contract_code" 
              :displayValue="false" 
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import VueBarcode from 'vue-barcode';
import AFitText from '@/shared/AFitText';

export default {
  name: "BarcodeBox",
  components: {VueBarcode, AFitText},
  props: {
    config: {
      type: Object,
      default: function() {
        return {
          margin_left: 0,
          margin_top: 0,
        }
      }
    },
    data: {
      type: Object,
      require: true
    },
  },
  computed: {
    ...mapGetters(["table_product", "table_product_category"]),
    boxMargin() {
      let margin_top = this.config.margin_top ? this.config.margin_top + "px" : 0;
      let margin_left = this.config.margin_left ? this.config.margin_left + "px" : 0;
      return "" + margin_top + " 0 0 " + margin_left;
    },
  },
  methods: {
    getProductCategory(data) {
      let p = this.table_product.find(p => p.id === data.product_id);
      if (!p || p.categories.length < 1) { return ''; }
      let pc = this.table_product_category.find(pc => pc.id === p.categories[0].product_category_id);
      if (!pc) { return ''; }
      return '(' + pc.name + ')';
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";
.BarcodeBox {
  width: 540px;
  height: 520px;
  padding: 10px 10px;
  .customer_name {
    font-size: 40px;
  }
  .barcode__table {
    width: 540px;
    font-size: 30px;
    margin-top: 30px;
    border-collapse: collapse;
  }
  .barcode {
    height: 60px;
    > div {
      padding: 10px 5px;
      > div {
        margin-right: 15px;
      }
    }
  }
}
</style>
<style type="text/css" media="print"> 
.BarcodeBox {
  size: 100mm 100mm;
  font-family: "돋움";
  page-break-after: always;
} 
</style>

